import {
    AccountMagicLink, ClientSecret,
    CredentialsObj,
    EnterpriseAdminDetailsObj,
    EnterpriseLevelsInformation,
    PartnerBankInfo,
    PartnerCreditCardDetailsObject,
    PartnerInvoicesObject,
    PartnerThirdPartyBillingDetailsObject,
} from "../Model/businessObjects";
import {SelectedCompanyForAnalytics} from "../Model/analyticsObjects";
import {ACHBankInfo} from "../Model/enterpriseObjects";
import { EmailsObject } from "../Model/notificationObjects";

export const constructCredentialsObj = (email, pass) => {
    return new CredentialsObj(email, pass);
}

export const constructEnterpriseDetails = (adminObject) => {
    return new EnterpriseAdminDetailsObj(adminObject);
}

export const constructEnterpriseLevelsDetails = (levelsInfo) => {
    return new EnterpriseLevelsInformation(levelsInfo);
}

export const constructPartnerInvoice = (invoicesArr) => {
    return new PartnerInvoicesObject(invoicesArr);
}

export const constructPartnerCardDetails = (last4Digits, expireMonth, expireYear) => {
    return new PartnerCreditCardDetailsObject(last4Digits, expireMonth, expireYear);
}

export const constructPartnerBankInfo = (name, routing, acc, paypal) => {
    return new PartnerBankInfo(name, routing, acc, paypal);
}

export const constructThirdPartyBillingDetails = (billingArr) => {
    return new PartnerThirdPartyBillingDetailsObject(billingArr);
}

export const constructCompanyIdList = (listArr) => {
    return new SelectedCompanyForAnalytics(listArr);
}

export const constructMagicLink = (link) => {
    return new AccountMagicLink(link);
}

export const constructClientSecret = (secret) => {
    return new ClientSecret(secret);
}

export const constructACHBankInfo = (bankName, last4Digits, routingNo, email, customerId) => {
    return new ACHBankInfo(bankName, last4Digits, routingNo, email, customerId);
}

export const constructEmails = (emails) => {
    return new EmailsObject(emails);
}
